import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

const MeshGradient = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: -1,
                overflow: 'hidden',
                background: '#020617',
            }}
        >
            {/* Cyan Blob */}
            <motion.div
                animate={{
                    x: [0, 100, 0],
                    y: [0, 50, 0],
                    scale: [1, 1.2, 1],
                }}
                transition={{
                    duration: 10,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
                style={{
                    position: 'absolute',
                    top: '10%',
                    left: '15%',
                    width: '400px',
                    height: '400px',
                    background: 'radial-gradient(circle, rgba(34, 211, 238, 0.15) 0%, rgba(34, 211, 238, 0) 70%)',
                    borderRadius: '50%',
                    filter: 'blur(60px)',
                }}
            />
            
            {/* Purple Blob */}
            <motion.div
                animate={{
                    x: [0, -80, 0],
                    y: [0, 120, 0],
                    scale: [1, 1.1, 1],
                }}
                transition={{
                    duration: 15,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
                style={{
                    position: 'absolute',
                    bottom: '15%',
                    right: '10%',
                    width: '500px',
                    height: '500px',
                    background: 'radial-gradient(circle, rgba(129, 140, 248, 0.15) 0%, rgba(129, 140, 248, 0) 70%)',
                    borderRadius: '50%',
                    filter: 'blur(80px)',
                }}
            />

            {/* Deep Blue Blob */}
            <motion.div
                animate={{
                    x: [0, 50, 0],
                    y: [0, -100, 0],
                    scale: [1, 1.3, 1],
                }}
                transition={{
                    duration: 12,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
                style={{
                    position: 'absolute',
                    top: '40%',
                    right: '25%',
                    width: '450px',
                    height: '450px',
                    background: 'radial-gradient(circle, rgba(30, 64, 175, 0.1) 0%, rgba(30, 64, 175, 0) 70%)',
                    borderRadius: '50%',
                    filter: 'blur(70px)',
                }}
            />
        </Box>
    );
};

export default MeshGradient;
